/** @format */

import React from "react"
import {
	ActionButton,
	Container,
	LightText,
	Title,
	BuyMorePicture,
	RightContainer,
	Row,
} from "./BannerBuyMore.styled"
import { BuyMorePopin } from "../BuyMorePopin/BuyMorePopin"
import { BannerBuyMoreProps } from "./BannerBuyMore.types"

export const BannerBuyMore = (props: BannerBuyMoreProps) => {
	const [isPopinBuyMoreOpen, setIsPopinBuyMoreOpen] = React.useState(false);
	
	return (
		<>
			<Container data-testid="buy-more-banner">
				<BuyMorePicture/>
				<RightContainer>
					<Row>
						<Title>Augmentez votre impact </Title>
					</Row>
					<Row>
						<LightText>
							Achetez davantage de boosts email et liste pour améliorer la
							visibilité de vos annonces auprès des acheteurs potentiels.
						</LightText>
						<ActionButton
							size="large"
							kind="secondaryDark"
							variant="normal"
							tag="button"
							testID="btn-buy-more-popin"
							onClick={() => setIsPopinBuyMoreOpen(true)}
							onPointerEnterCapture={undefined}
							onPointerLeaveCapture={undefined}
						>
							Acheter plus de boosts
						</ActionButton>
					</Row>
				</RightContainer>
			</Container>
			<BuyMorePopin
				open={isPopinBuyMoreOpen}
				onClosePopin={value => setIsPopinBuyMoreOpen(value)}
				buyMoreBoostsDistribution={props.buyMoreBoostsDistribution}
			/>
		</>
		
	)
}
